// @flow

import styled from 'styled-components';
import { ERROR_ICON_BACKGROUND } from '../brand';
import {
  Container,
  Content,
  Title,
  Subtitle,
  SubmitButton,
} from './success-screen.styles';

export { Container, Content, Title, Subtitle };

export const ErrorIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
  border-radius: 50%;
  color: ${props => props.theme.colors.feedback.error[500]};
  background: ${ERROR_ICON_BACKGROUND};
`;

export const RetryButton = styled(SubmitButton)`
  max-width: 280px;
`;
